import { FC } from "react";

interface SpinnerProps {
    
}
 
const Spinner: FC<SpinnerProps> = () => {
    return <div className='spinner'></div>;
}
 
export default Spinner;